"use strict";

module.exports = require("./Facebook.js");